export default function IconFeature({icon, title, subtitle, size}) {
    return (
        <div className={"flex flex-col items-center justify-center text-center"}>
            {icon && (
                <div className={"[&>svg]:size-full " + (size === 'lg' ? 'size-[80px] mb-[24px]' : 'size-[56px] mb-[16px]')}>
                    {icon}
                </div>
            )}
            {title && (
                <div className="text-[16px] leading-[20px] font-bold">
                    {title}
                </div>
            )}
            {subtitle && (
                <div className="text-small">
                    {subtitle}
                </div>
            )}
        </div>
    )
}
